import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { PricingInterface } from '@fortem-monorepo/web-sdk'

export const useRunStressTestsMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: async (body: PricingInterface.RunBody) => {
      const defaultBody = {
        ...body,
        recipient: 'noreply@fortemcapital.com',
        instance_tag: 'LOCALINST1',
      } as const

      return await Promise.all([
        api.pricingInterface.runRisk({
          ...defaultBody,
          input_type: 'default_risk',
        }),
        api.pricingInterface.runScenario({
          ...defaultBody,
          input_type: 'default_scenario',
        }),
      ])
    },
    onSuccess: (_data, _params) => {
      toast.success(`Stress tests started`)
    },
  })
}

export const useRunNPVMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: PricingInterface.RunNPVBody) => {
      return api.pricingInterface.runNPV(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`NPV started`)
    },
  })
}

export const useRunRiskMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: PricingInterface.RunRiskBody) => {
      return api.pricingInterface.runRisk(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Risk started`)
    },
  })
}

export const useRunScenarioMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: PricingInterface.RunScenarioBody) => {
      return api.pricingInterface.runScenario(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Scenario started`)
    },
  })
}
